import { Box, Row } from '@stenajs-webui/core';
import { ModalCloseButton } from '@stenajs-webui/modal';
import type { ReactNode } from 'react';

interface ModalHeaderContainerProps {
  children: ReactNode;
  className?: string;
  onRequestClose: () => void;
}

export function ModalHeaderContainer({
  children,
  className,
  onRequestClose,
}: ModalHeaderContainerProps) {
  return (
    <Row className={className} gap={2}>
      <Box width={48} display={['block', null, 'none']} />
      <Box gap={2} flexDirection={['column', null, 'row']} alignItems={'center'} width={'100%'}>
        {children}
      </Box>
      <ModalCloseButton onClick={onRequestClose} aria-label={'Close'} />
    </Row>
  );
}
